import {SET_HIDE_UPGRADE_WALL} from '@/store/mutationTypes'

export default {
  actions: {
    setHideUpgradeWall({commit}, hide = true) {
      commit(SET_HIDE_UPGRADE_WALL, hide)
    },
  }
}